const showEventHappening = false;
const showThankyouMessage = false;

const SPARK_BODY_CLASSES = {
  active: 'siteInfoBannerOn',
  past: 'siteInfoBannerWidgetDateIsPast',
  happening: 'siteInfoBannerWidgetEventHappening',
};

const ONE_MINUTE_MS = 60000;
const ONE_HOUR_MS = 3600000;
const ONE_DAY_MS = 86400000;
const ONE_SECOND_MS = 1000;

// Build the target date by adding the number of days Spark calculated to today's date.
// Time is zeroed out so the countdown always targets midnight of the event day.
function getEventTargetDate(numberOfDays) {
  const target = new Date();
  target.setDate(target.getDate() + numberOfDays);
  target.setHours(0, 0, 0, 0);
  return target;
}

// Calculate how much time is left between now and the target date
function calculateTimeRemaining(targetDate) {
  const remainingMs = targetDate - Date.now();
  if (remainingMs <= 0) return { days: 0, hours: 0, minutes: 0 };
  return {
    days: Math.floor(remainingMs / ONE_DAY_MS),
    hours: Math.floor((remainingMs % ONE_DAY_MS) / ONE_HOUR_MS),
    minutes: Math.floor((remainingMs % ONE_HOUR_MS) / ONE_MINUTE_MS),
    seconds: Math.floor((remainingMs % ONE_MINUTE_MS) / ONE_SECOND_MS),
  };
}

// Ensure single digit numbers are displayed with a leading zero
function formatWithLeadingZero(number) {
  return String(number).padStart(2, '0');
}

// Write days, hours and minutes into their respective DOM elements
function updateCountdownDisplay(timeRemaining) {
  const fieldIds = { days: 'days', hours: 'hours', minutes: 'minutes', seconds: 'seconds' };
  Object.entries(fieldIds).forEach(([key, id]) => {
    $(`#${id}`).text(formatWithLeadingZero(timeRemaining[key]));
  });
}

function hideCountdown() {
  $('.numeric-countdown').hide();
}

function isCountdownZero(timeRemaining) {
  return (
    timeRemaining.days === 0 &&
    timeRemaining.hours === 0 &&
    timeRemaining.minutes === 0 &&
    timeRemaining.seconds === 0
  );
}

// Read the number of days Spark already calculated and rendered in .countdownDays
function getNumberOfDaysFromSpark() {
  const match = $('.countdownDays').text().match(/\d+/);
  return match ? Number.parseInt(match[0], 10) : null;
}

function startCountdown(numberOfDays) {
  const targetDate = getEventTargetDate(numberOfDays);
  const timeRemaining = calculateTimeRemaining(targetDate);

  // If time has already run out, hide the countdown instead of showing zeros
  if (isCountdownZero(timeRemaining)) {
    hideCountdown();
    return;
  }

  updateCountdownDisplay(timeRemaining);

  // Refresh the display every minute — seconds are not shown so a 1s interval is unnecessary
  setInterval(() => updateCountdownDisplay(calculateTimeRemaining(targetDate)), ONE_SECOND_MS);
}

// Spark sets the body class and populates .countdownDays in separate async steps.
// If the body class is already set but .countdownDays is still empty, this observer
// waits for the content to appear before starting the countdown, avoiding a race condition
// where getNumberOfDaysFromSpark() would return null and the countdown would never show.
function waitForDaysContent() {
  const target = document.getElementById('eventName') ?? document.body;
  let debounceTimer = null;

  const observer = new MutationObserver(() => {
    const numberOfDays = getNumberOfDaysFromSpark();
    if (numberOfDays === null) return;

    // Spark animates the number down to the real value before settling.
    // We debounce to ensure we read the final value, not an intermediate one.
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const finalDays = getNumberOfDaysFromSpark();
      if (finalDays === null) return;
      observer.disconnect();
      startCountdown(finalDays);
    }, 300);
  });

  observer.observe(target, { childList: true, subtree: true, characterData: true });
}

function init() {
  const $body = $('body');

  // Hide the countdown when the event is in progress
  if ($body.hasClass(SPARK_BODY_CLASSES.happening)) {
    hideCountdown();
    if (showEventHappening) {
      $('#siteInfoBannerWidget').addClass('showDefault');
    }
    return;
  }

  // Hide the countdown when the event is ongoing or already finished
  if ($body.hasClass(SPARK_BODY_CLASSES.past)) {
    hideCountdown();
    if (showThankyouMessage) {
      $('#siteInfoBannerWidget').addClass('showDefault');
    }
    return;
  }

  // Do nothing if Spark has not marked the banner as active
  if (!$body.hasClass(SPARK_BODY_CLASSES.active)) return;

  const numberOfDays = getNumberOfDaysFromSpark();

  if (numberOfDays === null) {
    // Body class is set but .countdownDays is not populated yet — wait for it
    waitForDaysContent();
    return;
  }

  startCountdown(numberOfDays);
}

// Watch for Spark to add its body class before running the countdown logic
function waitForSparkWidget() {
  const $body = $('body');
  const { active, past } = SPARK_BODY_CLASSES;

  // Spark may have already added its class before this script ran
  if ($body.hasClass(active) || $body.hasClass(past)) {
    init();
    return;
  }

  const observer = new MutationObserver((mutations) => {
    const bodyClassChanged = mutations.some(
      (m) => m.type === 'attributes' && m.attributeName === 'class',
    );
    if (!bodyClassChanged) return;

    if ($body.hasClass(active) || $body.hasClass(past)) {
      observer.disconnect();
      init();
    }
  });

  observer.observe(document.body, { attributes: true });
}

export default function initCountdown() {
  // If the DOM is not ready yet, defer execution until it is
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSparkWidget);
  } else {
    waitForSparkWidget();
  }
}
